/**
 * Agents Module - AgentList Page
 * 
 * Lista de agentes disponibles
 */
export default function AgentList() {
  return (
    <div className="px-4 py-6 sm:px-0">
      <h1 className="text-3xl font-bold text-tf-text mb-6">Agentes</h1>
      <div className="bg-tf-bg-card shadow rounded-lg p-6">
        <p className="text-tf-text-muted">Lista de agentes - En desarrollo</p>
      </div>
    </div>
  )
}













